import { Injectable } from "@angular/core";
import { ActionWithPayload } from "@obg/ngrx-utils";

import { CommandType } from "./command-dispatcher.model";

const ACTION_PREFIX = "[Command]";
export const COMMAND_DISPATCHER_ACTION_TYPE = {
	trigger: `${ACTION_PREFIX} Trigger`,
};

@Injectable({
	providedIn: "root",
})
export class CommandDispatcherAction {
	trigger(payload: CommandType): ActionWithPayload {
		return {
			type: COMMAND_DISPATCHER_ACTION_TYPE.trigger,
			payload,
		};
	}
}
